import React from 'react';
import { useParams } from 'react-router-dom';
import UpdateForm from '../../Components/UpdateComponents/UpdateForm';
import { useGetProjectsQuery } from '../../features/projects/projectsApi';
import { useGetTaskQuery } from '../../features/tasks/tasksApi';
import { useGetTeamQuery } from '../../features/team/teamApi';

const EditTask = () => {
    const { id } = useParams();
    const { data: teams, isLoading: teamLoading, } = useGetTeamQuery()
    const { data: projects, isLoading: projectLoading } = useGetProjectsQuery()
    const { data: defaultData, isLoading: isDefaultDataLoading } = useGetTaskQuery(id)

    let content = null;
    if (teamLoading || projectLoading || isDefaultDataLoading) {
        content = <div>Loading...</div>
    }
    else if (!defaultData?.id) {
        content = <div>Data not found!</div>
    }
    else {
        content = <UpdateForm projects={projects} teams={teams} defaultData={defaultData}></UpdateForm>
    }
    return (
        <div className="container relative">
            <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
                <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
                    Update Task for Your Team
                </h1>

                <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
                    {content}
                </div>
            </main>
        </div>
    );
};

export default EditTask;